<div class="user-terms-conditions-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title class="no-capitalize">{{ title }}</h2>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="spinner-container">
        <div class="terms" [innerHTML]="content" *ngIf="!useDynamicContent"></div>
        <div class="terms" [innerHTML]="dynamicContent" *ngIf="useDynamicContent"></div>
        <upsc-element-blocker *ngIf="isTermsLoading"></upsc-element-blocker>
    </mat-dialog-content>
    <div class="page-actions" *ngIf="hasButtons">
        <button mat-raised-button class="page-action alternative-button" type="button" (click)="decline()">{{ 'decline' | translate }}</button>
        <button mat-raised-button class="page-action" type="button" (click)="nextStep()">{{ 'accept' | translate}}</button>
    </div>
    <div class="terms-content agree" *ngIf="showCheckbox">
        <mat-checkbox [(ngModel)]="agreed" name="agreed" (ngModelChange)="nextStep()">
            {{ 'agreeTermsConditions' | translate }}
        </mat-checkbox>
    </div>
</div>
